import { assertValidVersion } from "@tsparticles/engine";
import { SizeUpdater } from "./SizeUpdater.js";
export async function loadSizeUpdater(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addParticleUpdater("size", () => {
        return Promise.resolve(new SizeUpdater());
    }, refresh);
}
